// External libs
import React from 'react';
// OpenSankey+ types
import { ExempleItem } from './import/OpenSankey';
export const itemDemo = (applicationContext, applicationData, applicationState, exemple_menu, launch, Reinitialization) => {
    return React.createElement(ExempleItem, { applicationContext: applicationContext, applicationData: applicationData, applicationState: applicationState, exemple_menu: exemple_menu, current_path: '', launch: launch, Reinitialization: Reinitialization, initial_list: true });
};
